module.exports = __webpack_public_path__ + "static/media/PI.92d02aba.jpg";